import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { createCapabilityGroupForm } from 'services/capabilityGroups/duck';
import { push } from 'connected-react-router';
import EditForm from 'components/organisms/forms/EditCapabilityGroup';

class CreateCapabilityGroupContainer extends Component {
    render() {
        return (
            <EditForm
                handleSubmit={this.props.handleSubmit.bind(null, createCapabilityGroupForm)}
                currentUser={this.props.currentUser}
                cancel={() => this.props.push('/admin/capability-groups')} >
                {this.props.children}
            </EditForm>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.users.currentUser
});

export default compose(
    connect(mapStateToProps, { push }),
    reduxForm({
        form: 'createCapabilityGroup',
        enableReinitialize: true,
        initialValues: {
            Capabilities: []
        }
    })
)(CreateCapabilityGroupContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/capabilityGroups/CreateCapabilityGroupContainer.js